// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h6pM","right":"styles_right__3wv1N"};